import { z } from "zod";

export const summonRoomSystemSchema = z.object({
  roomSystem: z.string().optional(),
});

export type SummonRoomSystemFormData = z.infer<typeof summonRoomSystemSchema>;
